import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InitialState, Leave, LeaveMaster } from './type'
import {
  applyLeave,
  approveLeave,
  createLeaveMaster,
  getLeaveDetails,
  getLeaveMasterDetails,
  getLeaveStatus,
  getLeaveStatusDetails,
  rejectLeave
} from './api'

const initialState: InitialState = {
  isLoading: false,
  leaveDetails: [],
  leaveMasterDetails: [],
  selectedLeave: null,
  error: '',
  applyLeaveDetails: {
    leaveName: '',
    leaveType: '',
    fromDate: '',
    toDate: '',
    remarks: '',
    dayStatus: '',
    userId: ''
  }
}

export const manageLeaveSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    resetSelectedLeave: (state) => {
      state.selectedLeave = null
    },
    resetLeaveDetails: (state) => {
      state.leaveDetails = []
    }
  },
  extraReducers: {
    [applyLeave.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [applyLeave.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [applyLeave.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to apply leave. Please try again later.'
    },
    [createLeaveMaster.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [createLeaveMaster.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [createLeaveMaster.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to create leave. Please try again later.'
    },
    [getLeaveDetails.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Leave>>
    ) => {
      state.isLoading = false
      state.leaveDetails = action?.payload
    },
    [getLeaveDetails.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getLeaveDetails.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to get leave details. Please try again later.'
    },
    [getLeaveMasterDetails.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<LeaveMaster>>
    ) => {
      state.isLoading = false
      state.leaveMasterDetails = action?.payload
    },
    [getLeaveMasterDetails.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getLeaveMasterDetails.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error =
        'Unable to get leave master details. Please try again later.'
    },
    [getLeaveStatusDetails.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<Leave>>
    ) => {
      state.isLoading = false
      state.leaveDetails = action?.payload
    },
    [getLeaveStatusDetails.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getLeaveStatusDetails.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to get leave details. Please try again later.'
    },
    [getLeaveStatus.fulfilled.toString()]: (
      state,
      action: PayloadAction<Leave>
    ) => {
      state.isLoading = false
      state.selectedLeave = action?.payload
    },
    [getLeaveStatus.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getLeaveStatus.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to get leave Status. Please try again later.'
    },
    [approveLeave.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [approveLeave.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [approveLeave.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to approve leave. Please try again later.'
    },
    [rejectLeave.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [rejectLeave.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [rejectLeave.rejected.toString()]: (state) => {
      state.isLoading = false
      state.error = 'Unable to reject leave. Please try again later.'
    }
  }
})

export default manageLeaveSlice.reducer
